let accordionItem = document.getElementsByClassName('Accordion__item');
let accordionWrapper = document.getElementsByClassName('Accordion__item--wrapper');

let state;

for (i = 0; i < accordionWrapper.length; i++) {
    accordionWrapper[i].addEventListener('click', toggleItem, false);
}

function toggleItem() {

    let itemClass = this.parentNode.className;
    let state = this.getAttribute("data-state");

    if (state === "collapsed") {
        this.firstChild.nextElementSibling.nextElementSibling.className = 'Accordion__item--icon Accordion__item--opening';
        this.firstChild.nextElementSibling.nextElementSibling.nextElementSibling.className = 'Accordion__item--icon';
        this.setAttribute("data-state", "open");

        this.setAttribute("data-info", "active");

    } else if (state === "open") {
        this.firstChild.nextElementSibling.nextElementSibling.className = 'Accordion__item--icon';
        this.firstChild.nextElementSibling.nextElementSibling.nextElementSibling.className = 'Accordion__item--icon Accordion__item--opening';
        this.setAttribute("data-state", "collapsed");

        this.setAttribute("data-info", "active");
    }

    for (i = 0; i < accordionItem.length; i++) {

        accordionItem[i].className = 'Accordion__item Accordion__item--close';
      
        if (accordionItem[i].firstElementChild.getAttribute("data-info") === "inactive") {

            accordionItem[i].firstElementChild.children[1].className = 'Accordion__item--icon';
            accordionItem[i].firstElementChild.children[2].className = 'Accordion__item--icon Accordion__item--opening'; 
            accordionItem[i].firstElementChild.setAttribute("data-state", "collapsed");
        }
    }
    this.setAttribute("data-info", "inactive");
   
    if (itemClass == 'Accordion__item Accordion__item--close') {
        this.parentNode.className = 'Accordion__item Accordion__item--open';
    }
}